<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ (isNew ? 'department.edit.titleAdd' : 'department.edit.titleEdit') | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <form [formGroup]="formGroup">
              <div class="mb-3">
                <label for="name" class="form-label">{{ 'department.edit.nameLabel' | translate }}</label>
                <input type="text" class="form-control" id="name" maxlength="100" formControlName="name"
                  [placeholder]="'department.edit.namePlaceholder' | translate">
                <field-error-component [field]="'name'" [label]="'department.edit.nameFieldLabel' | translate"
                  [formGroup]="formGroup"></field-error-component>
              </div>

              <div class="mb-3">
                <label for="description" class="form-label">{{ 'department.edit.descriptionLabel' | translate }}</label>
                <input type="text" class="form-control" id="description" maxlength="100" formControlName="description"
                  [placeholder]="'department.edit.descriptionPlaceholder' | translate">
                <field-error-component [field]="'description'" [label]="'department.edit.descriptionFieldLabel' | translate"
                  [formGroup]="formGroup"></field-error-component>
              </div>
            </form>

            @if (teamList) {
              <div class="mt-4">
                <h4 class="mb-3">{{ 'department.edit.team' | translate }}</h4>
                <div class="team-list">
                  @for (team of teamList; track $index) {
                    <div class="card mb-3">
                      <div class="card-header  d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <i class="ri-team-line me-2"></i>
                          <h5 class="mb-0">{{ team.name }}</h5>
                        </div>
                        <div>
                          @if (team.active) {
                            <span class="badge bg-success">{{ 'department.edit.active' | translate }}</span>
                          } @else {
                            <span class="badge bg-danger">{{ 'department.edit.inactive' | translate }}</span>
                          }
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-2">
                          <span class="form-label">{{ 'department.edit.supervisorsCount' | translate }}</span>
                          <span class="fw-medium">{{ operatingMembers(team.supervisors).length }}</span>
                        </div>
                        <div class="d-flex justify-content-between mb-3">
                          <span class="form-label">{{ 'department.edit.agentsCount' | translate }}</span>
                          <span class="fw-medium">{{ operatingMembers(team.agents).length }}</span>
                        </div>
                        <div class="d-flex justify-content-center gap-2">
                          <button type="button" class="btn btn-outline-secondary" (click)="expand($index)">
                            <i class="ri-eye-line me-1"></i> {{ (indexExpanded === $index ? 'department.edit.hideDetails' : 'department.edit.viewDetails') | translate }}
                          </button>
                          <button type="button" class="btn btn-outline-secondary" (click)="editTeam($index)">
                           <i class="ri-edit-line me-1"></i> {{ 'department.edit.editTeam' | translate }}
                          </button>
                          <button type="button" class="btn btn-outline-secondary" (click)="schedule()">
                           <i class="ri-time-line me-1"></i> {{ 'department.edit.schedules' | translate }}
                          </button>
                          @if (team.active) {
                            <button type="button" class="btn btn-outline-danger" (click)="activateInactivateTeam(team, $index)">
                              <i class="ri-indeterminate-circle-line me-1"></i> {{ 'department.edit.deactivate' | translate }}
                            </button>
                          } @else {
                            <button type="button" class="btn btn-outline-success" (click)="activateInactivateTeam(team, $index)">
                              <i class="ri-check-double-fill me-1"></i> {{ 'department.edit.activate' | translate }}
                            </button>
                          }
                        </div>

                        @if (indexExpanded === $index) {
                          <div class="mt-3 pt-3 border-top">
                            <div class="row">
                              <div class="col-md-6">
                                <h6 class="fw-semibold mb-3">{{ 'department.edit.supervisors' | translate }}</h6>
                                @if (operatingMembers(team.supervisors).length > 0) {
                                  @for (supervisor of operatingMembers(team.supervisors); track supervisor._id) {
                                    <div class="d-flex align-items-center mb-2">
                                      <div class="avatar-sm me-2">
                                        <img [src]="getUserImage(supervisor)" class="rounded-circle avatar-xs" [alt]="'department.edit.supervisorAlt' | translate">
                                      </div>
                                      <div class="flex-grow-1">
                                        <h6 class="mb-0">{{supervisor.name}}</h6>
                                        <small class="text-muted">{{supervisor.email}}</small>
                                      </div>
                                      <button class="btn btn-link text-danger p-0" (click)="removeSupervisor(team, supervisor)">
                                        <i class="ri-delete-bin-line"></i>
                                      </button>
                                    </div>
                                  }
                                } @else {
                                  <p class="text-muted">{{ 'department.edit.noSupervisor' | translate }}</p>
                                }
                              </div>

                              <div class="col-md-6">
                                <h6 class="fw-semibold mb-3">{{ 'department.edit.agents' | translate }}</h6>
                                @if (operatingMembers(team.agents).length > 0) {
                                  @for (agent of operatingMembers(team.agents); track agent._id) {
                                    <div class="d-flex align-items-center mb-2">
                                      <div class="avatar-sm me-2">
                                        <img [src]="getUserImage(agent)" class="rounded-circle avatar-xs" [alt]="'department.edit.agentAlt' | translate">
                                      </div>
                                      <div class="flex-grow-1">
                                        <h6 class="mb-0">{{agent.name}}</h6>
                                        <small class="text-muted">{{agent.email}}</small>
                                      </div>
                                      <button class="btn btn-link text-danger p-0" (click)="removeAgent(team, agent)">
                                        <i class="ri-delete-bin-line"></i>
                                      </button>
                                    </div>
                                  }
                                } @else {
                                  <p class="text-muted">{{ 'department.edit.noAgent' | translate }}</p>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'department.edit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="!formGroup.valid || loading || (!isNew && !teamsLoaded)"
        (click)="save()"
      >
        {{ (isNew ? 'department.edit.save' : 'department.edit.update') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>
